var React = require('react');

function LetterStripesVertical (props) {
    return React.createElement("svg",props,[React.createElement("g",{"key":0},[React.createElement("polygon",{"points":"268.917,0 267.836,0 428.937,427.799 430.019,427.799 \t","key":0}),React.createElement("polygon",{"points":"179.78,0 178.723,0 307.911,427.799 308.969,427.799 \t","key":1})]),React.createElement("g",{"key":1},[React.createElement("polygon",{"points":"162.028,0 163.115,0 1.089,427.799 0,427.799 \t","key":0}),React.createElement("polygon",{"points":"251.678,0 252.741,0 122.81,427.799 121.746,427.799 \t","key":1})])]);
}

LetterStripesVertical.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"430.019px","height":"427.799px","viewBox":"0 0 430.019 427.799","enableBackground":"new 0 0 430.019 427.799","xmlSpace":"preserve"};

module.exports = LetterStripesVertical;

LetterStripesVertical.default = LetterStripesVertical;
